import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { InboundFax } from '../../../core/models/inbound-fax.model';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-inbound-fax-duplicate-prompt',
    templateUrl: './inbound-fax-duplicate-prompt.component.html',
    styleUrls: ['./inbound-fax-duplicate-prompt.component.scss'],
    imports: [MatIcon, MatTooltip, FormsModule, ReactiveFormsModule]
})
export class InboundFaxDuplicatePromptComponent implements OnInit {
  private formBuilder = inject(FormBuilder);


  @Input() inboundFax: InboundFax;
  @Output() submitted = new EventEmitter<{ duplicate: boolean }>();

  formGroup: FormGroup;
  submitEnabled = false;

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      duplicate: []
    });

    this.formGroup.valueChanges.subscribe(value => {
      this.submitEnabled = value !== null;
    });
  }

  onSubmitClick() {
    this.submitted.emit({ duplicate: this.formGroup.value.duplicate });
  }
}
